class TagService {

    getActiveTagsFromParam(filterCategories, tagParams: string[]) {
        if (!tagParams) {
            return [];
        }
        const allTags = filterCategories.flatMap(
            (filterCategory) => filterCategory.tags
        );
        const selectedTags = tagParams.map((tagParam) =>
            allTags.find((tag) => tag.slug === tagParam)
        );
        return selectedTags;
    }
}

export const tagService = new TagService();
